import { taxonomyTypeValues } from '@/configuration/pages/ConfigurationPage/constants'

import { taxonomyDisplayValues } from './constants'

export const getTaxonomyDisplayOptions = (taxonomyType, t) => {
  let allLabel = ''
  let includedLabel = ''
  let excludedLabel = ''

  if (taxonomyType === taxonomyTypeValues.category) {
    allLabel = t('Todas las categorías de producto')
    includedLabel = t('Categorías de producto seleccionadas')
    excludedLabel = t('Todas las categorías de producto no excluidas')
  } else if (taxonomyType === taxonomyTypeValues.collection) {
    allLabel = t('Todas las colecciones')
    includedLabel = t('Colecciones seleccionadas')
    excludedLabel = t('Todas las colecciones no excluidas')
  } else if (taxonomyType === taxonomyTypeValues.productType) {
    allLabel = t('Todos los tipos de producto')
    includedLabel = t('Tipos de producto seleccionados')
    excludedLabel = t('Todos los tipos de producto no excluidos')
  }

  return [
    {
      value: taxonomyDisplayValues.all,
      label: allLabel,
    },
    {
      value: taxonomyDisplayValues.included,
      label: includedLabel,
    },
    {
      value: taxonomyDisplayValues.excluded,
      label: excludedLabel,
    },
  ]
}

export const getExchangeTaxonomyIdsLabelByDisplayAndType = (displayValue, type, t) => {
  let label = ''

  if (type === taxonomyTypeValues.category) {
    if (displayValue === taxonomyDisplayValues.included) {
      label = t('Categorías de producto seleccionadas')
    } else if (displayValue === taxonomyDisplayValues.excluded) {
      label = t('Categorías de producto excluidas')
    }
  }

  if (type === taxonomyTypeValues.collection) {
    if (displayValue === taxonomyDisplayValues.included) {
      label = t('Colecciones seleccionadas')
    } else if (displayValue === taxonomyDisplayValues.excluded) {
      label = t('Colecciones excluidas')
    }
  }

  if (type === taxonomyTypeValues.productType) {
    if (displayValue === taxonomyDisplayValues.included) {
      label = t('Tipos de producto seleccionados')
    } else if (displayValue === taxonomyDisplayValues.excluded) {
      label = t('Tipos de producto excluidos')
    }
  }

  return label
}

export const getExchangeTaxonomyIdsOptionsByTaxonomyType = ({
  type,
  productCategories,
  productCollections,
  productTypes,
}) => {
  if (type === taxonomyTypeValues.category) {
    return productCategories?.map(c => ({ label: c.name, value: c.id }))
  }

  if (type === taxonomyTypeValues.collection) {
    return productCollections?.map(c => ({ label: c.name, value: c.id }))
  }

  if (type === taxonomyTypeValues.productType) {
    return productTypes?.map(p => ({ label: p.name, value: p.id }))
  }

  return []
}
